import React from 'react';

import Context from '../../../../../../context';

import { useTranslation    } from 'react-i18next';
import { locationNamespace } from '../../../../../../types/location.namespace';
import { CustomDropdownFilter, CustomButton2, LocationDropdowns } from '../../../../../../components';

import "./index.sass";

const Filter: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { t } = useTranslation();
  const { setRequestCity } = React.useContext(Context.Location.City);
  const [ selectedProvince, setSelectedProvince ] = React.useState<locationNamespace.province.index | undefined>(undefined);

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function onSelectProvince(province: locationNamespace.province.index | undefined): void {
    setSelectedProvince(province);
    if (!province) return setRequestCity!({
      province: undefined,
      page: 1,
    });
    setRequestCity!({
      province: province._id,
      page: 1,
    });
  }

  function handleOnClickReFetch(): void {
    setSelectedProvince(undefined);
    setRequestCity!({ page: 1, limit: 10 });
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <div className="filter-container">
      <CustomDropdownFilter title={t("filter")} hoverTitle={t("filter")}>
        <LocationDropdowns.Province defaultItem={selectedProvince} onSelectItem={onSelectProvince} />
        <div className="filter-footer">
          <CustomButton2 onClick={handleOnClickReFetch} title={t('reset')} type='primary'/>
        </div>
      </CustomDropdownFilter>
    </div>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default Filter;
